import React from "react";
import { IonSpinner } from "@ionic/react";
import "./FlyDayCloseOverlay.css";

export function FlyDayCloseOverlay() {
  return (
    <div
      className="fly-day-close-backdrop"
      role="alertdialog"
      aria-modal="true"
      aria-busy="true"
      aria-live="polite"
      aria-label="Uzavírání letového dne"
    >
      <div className="fly-day-close-panel">
        <IonSpinner name="crescent" className="fly-day-close-spinner" />
        <p className="fly-day-close-text">Čekejte prosím,</p>
        <p className="fly-day-close-subtext">probíhá přepočítávání celkového náletu</p>
      </div>
    </div>
  );
}
